import React from "react";
import Advantage from "./components/advantage";
import Text from "@gc-npm/components.text";
import Image from "@gc-npm/components.c-image";
import Button from "@gc-npm/components.button";

const AdvantagesSection = (props) => {
  let listAdvantages = null;
  if (Object.keys(props).includes("Advantage-1")) {
    listAdvantages = Object.keys(props)
      .filter((key) => key.startsWith("Advantage-"))
      .map((key) => props[key]);
  } else {
    listAdvantages = Object.keys(props)
      .filter((key) => key.startsWith("Charac-"))
      .map((key) => props[key]);
  }

  return (
    <>
      <section
        className={`advantages-section ${
          Object.keys(props).includes("Advantage-1") &&
          (props.showMobile ? "" : "noShowMobile")
        }`}
      >
        <div className="container">
          {props["Image-1"] && (
            <div className={`img`}>
              <Image {...props["Image-1"]} />
            </div>
          )}
          {props["Text-1"] && (
            <Text
              cyData="Advantages Text-1"
              className="advantages-section-title"
              {...props["Text-1"]}
            />
          )}
          <ul
            className="advantages-section-list"
            data-cy="Advantages list items"
          >
            {listAdvantages &&
              listAdvantages.map((advantage, index) => (
                <li
                  key={`item-${index}`}
                  className="advantages-section-item"
                  data-cy="Advantages item"
                >
                  <Advantage {...advantage} />
                </li>
              ))}
          </ul>
          {props["Button-1"] && (
            <div className={`btn`}>
              <Button {...props["Button-1"]} />
            </div>
          )}
        </div>
      </section>
      <style jsx>
        {`.advantages-section {
  margin: 2rem 0;
  text-align: center;
  background-color: transparent;
}
.advantages-section :global(.advantages-section-title) {
  padding-bottom: 2rem;
}
.advantages-section .img {
  display: inline-block;
  margin-bottom: 1rem;
}
.advantages-section .btn {
  display: inline-block;
  margin-top: 1.5rem;
}
.advantages-section .advantages-section-list {
  display: grid;
  grid-template-columns: repeat(${props?.columns || "3"}, 1fr);
  gap: 5rem;
  justify-content: center;
}
@media screen and (max-width: 992px) {
  .advantages-section .advantages-section-list {
    gap: 1rem;
  }
  .advantages-section.noShowMobile {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .advantages-section .advantages-section-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}`}
      </style>
    </>
  );
};

export default AdvantagesSection;
